import { NotificationChannelTemplate } from './NotificationChannelTemplate';

export class EmailTemplate extends NotificationChannelTemplate {
  sendgrid_template_id?: string;
  bcc?: Array<string>;
}
